import { lazy } from 'react'

export const DisplaySimilarNamesModalAsync = lazy(() => import('./DisplaySimilarNamesModal')
    .then((module) => {
        return { default: module.DisplaySimilarNamesModal }
    })
)
